import { getRawMarketplaceAppPricing } from '@atlassian/mpac-api-client';
import { CurrencyCodeMap, HostingTypeToQueryParam } from '@atlassian/mpac-types';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { hooks, log } from '@atlassian/mpac-utils';
export var getPricingForApps = function getPricingForApps(mpacBaseUrl, apps, hostingType) {
  return Promise.all(apps.map(function (app) {
    return getRawMarketplaceAppPricing(mpacBaseUrl, app.value, CurrencyCodeMap.USD, HostingTypeToQueryParam[hostingType]);
  }));
};
export var useAppPricing = function useAppPricing(mpacBaseUrl, apps, hostingType) {
  var _hooks$usePromise = hooks.usePromise(function () {
    return getPricingForApps(mpacBaseUrl, apps, hostingType);
  }),
      result = _hooks$usePromise.result,
      error = _hooks$usePromise.error,
      pending = _hooks$usePromise.pending;

  if (error) {
    log.error('PricingTable/hooks', "Failed to retrieve apps pricing", {
      error: error
    });
  }

  return {
    pending: pending,
    error: error,
    appsPricing: result || []
  };
};